export class AnimateOnScroll {
    constructor()
    {
        this.spy_elements = document.querySelectorAll('[data-animate]');
        this.class_name_prefix = 'animate__';
        this.spy_elements_offsets = [];
        this.spy_elements_params = [];
        this.used_animations = [];


        this.configAnimationOnElements();

        // NOTE: Information for developer
        console.log(this.used_animations);
    }

    configAnimationOnElements()
    {
        this.spy_elements.forEach((elem) => {
            if(!elem.dataset.animate) {
              return;
            }

            elem.classList.add('animate__animated');
            this.getParams(elem);
            this.getOffset(elem);
        })
    }

    getParams(elem)
    {
        const animation = elem.dataset.animate;
        const delay = elem.dataset.animateDelay ? elem.dataset.animateDelay : 1000;
        const duration = elem.dataset.animateDuration ? elem.dataset.animateDuration : 1000;
        const repeat = elem.dataset.animateRepeat ? elem.dataset.animateRepeat : 1;

        let element_animation_params = {
            'elem': elem,
            'animation' : animation,
            'delay' : delay,
            'duration' : duration,
            'repeat' : repeat,
        };

        this.spy_elements_params.push(element_animation_params);
        this.used_animations.push(animation);
    }

    getOffset(elem)
    {
        const offsetElementOption = parseInt(elem.dataset.animateOffset ? elem.dataset.animateOffset : 0);

        let rect = elem.getBoundingClientRect();
        let y = rect.top;
        let animation_init_position = y + offsetElementOption;
        this.spy_elements_offsets.push(animation_init_position);
    }

    onScroll(depth, w, y)
    {

        for (let i = 0; i < this.spy_elements_offsets.length; i++) {
            let current_element = this.spy_elements_offsets[i];
            let offset = depth + y; // scroll from top + window height;
            if (offset >= current_element) {
                this.runAnimation(i);
            }
        }
    }

    runAnimation(elem_index)
    {
        const animation_params = this.spy_elements_params[elem_index];
        animation_params['elem'].style.animationDelay = animation_params['delay'] + 'ms';
        animation_params['elem'].style.animationDuration = animation_params['duration'] + 'ms';
        animation_params['elem'].style.animationIterationCount = animation_params['repeat'];
        animation_params['elem'].classList.add(this.class_name_prefix + animation_params['animation']);
    }

}
